module.exports = __webpack_public_path__ + "media/img/event/speakers/Henrietta-Lightwood-3bd4340c64f90065de1ede52880510a8.jpg";